import {AnyAction} from "redux";
import {
    FETCH_CHAMADA_DISCOFFER, GET_FREQUENCY_CALL_PRINTING_SUCCESS,
    FETCH_ATA_PRESENCA, RECEIVE_ATA_PRESENCA,
    FETCH_DOF_CONTENTS, RECEIVE_DOF_CONTENTS,
    FETCH_BATCH_DOF_CONTENTS, RECEIVE_BATCH_DOF_CONTENTS,
    FETCH_ATA_PRESENCA_BATCH, RECEIVE_ATA_PRESENCA_BATCH,
    TOGGLE_OK_SECRETARIA
} from "../actionTypes";


interface academicoState {
    chamadaDiscOffer : any[],
    ataPresenca: any,
    dofContents: any[],
    isFetchingAta: boolean,
    isFetchingDofContents: boolean,
    batchDofContents: { [key: number]: any[] },
    ataPresencaBatch: any[],
    isFetchingBatch: boolean,
    isFetchingBatchContents: boolean
}


const initialState : academicoState = {
    chamadaDiscOffer : [],
    ataPresenca: null,
    dofContents: [],
    isFetchingAta: false,
    isFetchingDofContents: false,
    batchDofContents: {},
    ataPresencaBatch: [],
    isFetchingBatch: false,
    isFetchingBatchContents: false
}

const academicoReducer = (state = initialState, action: AnyAction) => {

    switch (action.type) {

        case FETCH_CHAMADA_DISCOFFER:
            return {
                ...state,
                chamadaDiscOffer: []
            }
        case GET_FREQUENCY_CALL_PRINTING_SUCCESS:
            return {
                ...state,
                chamadaDiscOffer: action.payload
            }
        case FETCH_ATA_PRESENCA:
            return {
                ...state,
                isFetchingAta: true,
                ataPresenca: null
            }
        case RECEIVE_ATA_PRESENCA:
            return {
                ...state,
                isFetchingAta: false,
                ataPresenca: action.payload
            }
        case FETCH_DOF_CONTENTS:
            return {
                ...state,
                isFetchingDofContents: true,
                dofContents: []
            }
        case RECEIVE_DOF_CONTENTS:
            return {
                ...state,
                isFetchingDofContents: false,
                dofContents: action.payload
            }
        case FETCH_BATCH_DOF_CONTENTS:
            return {
                ...state,
                isFetchingBatchContents: true,
                batchDofContents: {}
            }
        case RECEIVE_BATCH_DOF_CONTENTS:
            return {
                ...state,
                isFetchingBatchContents: false,
                batchDofContents: action.payload
            }
        case FETCH_ATA_PRESENCA_BATCH:
            return {
                ...state,
                isFetchingBatch: true,
                ataPresencaBatch: []
            }
        case RECEIVE_ATA_PRESENCA_BATCH:
            return {
                ...state,
                isFetchingBatch: false,
                ataPresencaBatch: action.payload
            }
        case TOGGLE_OK_SECRETARIA: {
            const { contentId, okSecretaria } = action.payload;
            return {
                ...state,
                dofContents: state.dofContents.map((c: any) =>
                    c.id === contentId ? { ...c, okSecretaria } : c
                ),
                batchDofContents: Object.fromEntries(
                    Object.entries(state.batchDofContents).map(([key, contents]: [string, any]) => [
                        key,
                        (contents as any[]).map((c: any) =>
                            c.id === contentId ? { ...c, okSecretaria } : c
                        )
                    ])
                )
            };
        }
        default:
            return state;
    }
}

export default academicoReducer;
